// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qq0F","label":"styles_label__3rK8d"};